import { JobPhaseReceivableSheetInterface } from '../interfaces/job-phase-receivable-sheet.interface';
import { CommonEntityDto } from '../../common/dto/common-entity.dto';
import {
  IsBoolean,
  IsNumber,
  IsOptional,
  IsString,
  IsUUID,
} from 'class-validator';
import { Exclude, Expose } from 'class-transformer';
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

@Exclude()
export class JobPhaseReceivableSheetDto
  extends CommonEntityDto
  implements JobPhaseReceivableSheetInterface
{
  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  jobPhaseId!: string;

  @ApiPropertyOptional({ format: 'uuid' })
  @IsUUID()
  @IsOptional()
  @Expose()
  jobPhaseReceivableId!: string | null;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  phaseId!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  phaseName!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  subdivisionId!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  subdivisionName!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  regionId!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  regionName!: string;

  @ApiProperty({ format: 'uuid' })
  @IsUUID()
  @Expose()
  builderId!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  builderName!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  lot!: string;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @Expose()
  block!: string | null;

  @ApiPropertyOptional({ format: 'uuid' })
  @IsUUID()
  @IsOptional()
  @Expose()
  approvedById!: string | null;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @Expose()
  approvedByName!: string | null;

  @ApiPropertyOptional()
  @IsOptional()
  @Expose()
  dateApproved!: Date | null;

  @ApiProperty()
  @IsString()
  @Expose()
  address1!: string;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @Expose()
  address2!: string | null;

  @ApiProperty()
  @IsString()
  @Expose()
  city!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  state!: string;

  @ApiProperty()
  @IsString()
  @Expose()
  zip!: string;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  supplyProIntegrated!: boolean;

  @ApiProperty()
  @IsBoolean()
  @Expose()
  billed!: boolean;

  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  @Expose()
  invoicePOAmount!: number | null;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @Expose()
  internalInvoiceNumber!: string | null;
}
